/**
 * Project : workspace
 * File    : BusinesssNotificationScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.common.notification


import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.notification.viewModel.NotificationViewModel
import component.navigation.TopNavBar
import navigation.AppNavigator
import theme.ThemeColor

/**
 * Represents the business notification screen class.
 */

class BusinessNotificationScreen {
    @Composable
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val business = businessViewModel.myBusiness.collectAsState()
        val viewModel = NotificationViewModel(business.value)
        val allNotifications = viewModel.allData.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.retrieve()
        }
        Column(modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)) {
            TopNavBar("Notifications", onBackPress = {
                AppNavigator.shared().goBack()
            })
            LazyColumn(
                modifier = Modifier.fillMaxWidth().fillMaxHeight()
                    .background(
                        ThemeColor.shared().NotificationBg
                    )
            ) {
                items(allNotifications.value.count()) { index ->
//                    NotificationCard(allNotifications.value[index], viewModel)
                }
            }
        }
    }
}